import { createAction, props } from '@ngrx/store';

import { IMedicalLeave } from '@shared/interfaces/medical-leave.interface';
import { IParametersAssign } from '@shared/interfaces/parameters-assign-lm';

export const LOAD_MEDICAL_LICENCE = createAction('[EXPEDIENTES] Peticion Carga Expedientes');
export const LOAD_ALL_MEDICAL_LICENCE = createAction('[EXPEDIENTES] Peticion carga de todos los Expedientes');

export const LOAD_LM_PENDING_MEDICAL_CONTROLLER_SUCCESS = createAction(
  '[EXPEDIENTES] Licencias medicas pendientes por contraloria medica',
  props<{ lmRecords: IMedicalLeave[] }>(),
);

export const LOAD_ALL_LM_PENDING_MEDICAL_CONTROLLER_SUCCESS = createAction(
  '[EXPEDIENTES] Todas las LM pendientes por contraloria medica',
  props<{ lmRecords: IMedicalLeave[] }>(),
);

export const LOAD_LM_PENDING_SUBSIDY_SUCCESS = createAction(
  '[EXPEDIENTES] Licencias medicas pendientes por subsidio',
  props<{ lmRecords: IMedicalLeave[] }>(),
);
export const LOAD_ALL_LM_PENDING_SUBSIDY_SUCCESS = createAction(
  '[EXPEDIENTES] Todas las LM pendientes por subsidio',
  props<{ lmRecords: IMedicalLeave[] }>(),
);

export const LOAD_RR_REJECTION_SUCCESS = createAction(
  '[EXPEDIENTES] Recursos de Reposicion por rechazo',
  props<{ lmRecords: IMedicalLeave[] }>(),
);

export const LOAD_ALL_RR_REJECTION_SUCCESS = createAction(
  '[EXPEDIENTES] Todos los RR por rechazo',
  props<{ lmRecords: IMedicalLeave[] }>(),
);

export const LOAD_RR_REDUCTION_SUCCESS = createAction(
  '[EXPEDIENTES] Recursos de Reposicion por reduccion',
  props<{ lmRecords: IMedicalLeave[] }>(),
);

export const LOAD_ALL_RR_REDUCTION_SUCCESS = createAction(
  '[EXPEDIENTES] Todos los RR por reduccion',
  props<{ lmRecords: IMedicalLeave[] }>(),
);

export const LOAD_RR_NO_RIGHT_SUCCESS = createAction(
  '[EXPEDIENTES] Recursos de Reposicion sin derecho pago',
  props<{ lmRecords: IMedicalLeave[] }>(),
);

export const LOAD_ALL_RR_NO_RIGHT_SUCCESS = createAction(
  '[EXPEDIENTES] Todos los RR sin derecho pago',
  props<{ lmRecords: IMedicalLeave[] }>(),
);
export const LOAD_RR_PAYMENT_ERROR_SUCCESS = createAction(
  '[EXPEDIENTES] Recursos de Reposicion por error de pago',
  props<{ lmRecords: IMedicalLeave[] }>(),
);

export const LOAD_ALL_RR_PAYMENT_ERROR_SUCCESS = createAction(
  '[EXPEDIENTES] Todos los RR por error de pago',
  props<{ lmRecords: IMedicalLeave[] }>(),
);

export const LOAD_MEDICAL_LICENCE_FAIL = createAction(
  '[EXPEDIENTES] Error Carga Expedientes',
  props<{ payload: any }>(),
);

export const LOAD_MEDICAL_LICENCE_ASSIGN = createAction(
  '[EXPEDIENTES] Peticion Carga Expedientes Para Asignacion',
  props<{ params: IParametersAssign }>(),
);
export const LOAD_LM_ASSIGN_SUCCESS = createAction(
  '[EXPEDIENTES] Licencias medicas Para Asignar',
  props<{ lmRecords: IMedicalLeave[] }>(),
);
export const LOAD_LM_ASSIGN_SUCCESS_FAIL = createAction(
  '[EXPEDIENTES] Error Carga LM Para Asignar',
  props<{ payload: any }>(),
);

//TODO: comentar
